// this is empty because the only option that used to be here was Archive, but we removed that.
// kept this here so that we still have the structure for adding actions before a call
export const ActionsBeforeCall = () => {
  return <div className="[&>*]:w-full"></div>;
};
